// import './styles';
// import 'angular-cookie/angular-cookie.js';

import moment from 'moment';
import form from 'ngtemplate-loader!./form.tpl.html';

export const moduleName = 'rezflow.bundleForm'
export const name = 'bundleForm';

export class BundleForm {

  /* @ngInject */
  constructor($scope, $filter, BundleAPI, $state, $rootScope, $location) {
    const vm = this;
    this.$scope = $scope;
    this.$filter = $filter;
    this.api = BundleAPI;
    this.$state = $state;
    this.$location = $location;
    this.user = $rootScope.user;
    this.company = this.user ? this.user.activeCompany : undefined;
    this.getAgents();
    // Update concierge list based on hotel selection
    $scope.$watch('$ctrl.bundle.hotel', (n, o) => {
      if (n) {
        if (n._id) {
          this.concierges = [{ _id: null, name: '-- none --' }, ...Object.values(n.children)]
        } else {
          this.getConcierges();
        }
      }
    });

    $scope.$watch('$ctrl.package', (n, o) => {
      if (n) {
        if (n._id) {
          this.bundle.package = n._id;
        }
      }
    });

  }

  getConcierges() {
    const API = this.api.req();
    const Contacts = API.contacts({
      type: 'concierge'
    }).$promise;
    Contacts.then((res) => {
      this.concierges = [{ _id: null, name: '-- none --'}, ...Object.values(res.contacts)];
    })
  }

  getAgents() {
    const API = this.api.req();
    const Contacts = API.contacts({
      type: 'agent'
    }).$promise;
    Contacts.then((res) => {
      this.agents = [{ _id: null, name: '-- none --'}, ...Object.values(res.contacts)];
    })
  }


  defaultRules() {
    return {
      expiration: {
        label: "Expires On",
        type: "date",
        active: false,
        date: undefined,
      },
      redeemed_count: {
        label: "Usage Cap",
        type: "number",
        active: false,
        count: undefined,
      },
      booked_between: {
        label: "Booked Between",
        type: "date-range",
        active: false,
        start_date: undefined,
        end_date: undefined,
      },
      flight_between: {
        label: "Flight between",
        type: "date-range",
        active: false,
        start_date: undefined,
        end_date: undefined,
      }

    }
  }

  addToSelection(item, i) {
    this.itemSelection.length = i+1;

    item.count = 1;
    item.discount = "0";

    this.selectedItem = item;
    const children = item.children ? Object.values(item.children) : [];
    if(children.length) {
      this.itemSelection.push(Object.values(children));
    }
  }

  addItem(item) {
    this.bundle.items.push({
      count: item.count,
      discount: item.discount,
      discount_name: item.discount_name,
      value: item.value,
      product: item,
    });
    this.itemSelection = [this.products]
  }

  removeItem(index) {
    this.bundle.items.splice(index, 1);
  }

  saveBundle(bundle) {
    const req = this.api.req();
    const bundleReq = new req(bundle)
    const saveFn = () => this.isNew ? bundleReq.$save() : bundleReq.$update(bundle);
    saveFn().then(res => {
      this.postSave();
    })
  }

  postSave() {
    this.$state.go('admin', { tab: 'bundles'})
  }

  $onInit() {
    this.init();
  }

  $doCheck() {}

  $onChanges(changed) {}

  get isNew() {
    return this.bundle._id === undefined;
  }

  init() {
    this.bundle = Object.assign({}, this.bundle, {
      rules: angular.merge({}, this.defaultRules(), this.bundle.rules),
      active: true,
      items: angular.merge([], this.bundle.items)
    })
    this.selectedItem = undefined;
    this.itemSelection = [];
    this.itemSelection.push(this.products);
    this.package = this.bundle.package;
  }

}

export default (MODULE) => {

  angular.module(MODULE)
    .constant('isPublic', false)
    .component(name, {
      bindings: {
        bundle: '<',
        hotels: '<',
        concierges: '<',
        packages: '<',
        products: '<'
      },
      templateUrl: form,
      controller: BundleForm
    });

  return name;

};



// WEBPACK FOOTER //
// ./client/assets/scripts/modules/bundles/form.js